import type { NostrEvent } from '@nostrify/nostrify';
import { verifyEvent } from 'nostr-tools';

/**
 * Archive records that exist on Nostr but that the site's relays no longer
 * serve, kept here as exact signed copies so they still appear in the archive
 * and open from their links.
 *
 * Unlike the curated "pinned" notes, these are NOT featured: each is filed in
 * the feed by date like any other record. Every copy is re-checked (id and
 * signature) before it is used, so a mistyped or altered entry is simply
 * ignored rather than shown.
 *
 * To add one, paste the note's full event JSON from a viewer that still has it
 * (for example njump.me/<note id>) as a new entry below, keeping the content
 * character for character, including spaces and line breaks.
 */
const RECOVERED_EVENTS: NostrEvent[] = [
  // "Fresh Kills Landfill - Staten Island, 2001."
  {
    id: '76cce7dad20f91057fea9682564c3d2a35b36493c6f6b471debd5f18313812d8',
    pubkey: '90152b7f8dffbcfc462f5c02f122f72e3bae58ccb059431367e2790204e57401',
    created_at: 1743562249,
    kind: 1,
    tags: [
      [
        'imeta',
        'url https://m.primal.net/QBOI.jpg',
        'm image/jpeg',
        'ox df65b153c8b2c1acaf267dad9bc0c95c3ad77c629d9eb9c902b4092d82616272',
        'dim 1600x1200',
      ],
    ],
    content: 'Fresh Kills Landfill - Staten Island, 2001. \n\nhttps://m.primal.net/QBOI.jpg\n',
    sig: '7b2657049182aaf53252e5a554707c0fe27ed27017b73c0f6b5e3aa546f39fc0e555e8ce939b7c6caca993874a90219d712351b82c7fcfc461d30eb50d4db1d6',
  },
];

let verified: NostrEvent[] | null = null;

/** The recovered records whose id and signature check out. */
export function getRecoveredNotes(): NostrEvent[] {
  if (!verified) {
    verified = RECOVERED_EVENTS.filter((ev) => {
      try {
        return verifyEvent(ev);
      } catch {
        return false;
      }
    });
    if (verified.length !== RECOVERED_EVENTS.length) {
      console.warn('[recovered] some recovered records failed signature checks and were skipped');
    }
  }
  return verified;
}

/** A recovered record by id, or null. */
export function findRecoveredNote(id: string): NostrEvent | null {
  return getRecoveredNotes().find((ev) => ev.id === id) ?? null;
}
